import Advertisements from "./Advertisements"

export default  Advertisements;
